import React, { useContext, useEffect, useState } from 'react';
import SnsIcon from '../components/SnsIcon';

import { LayoutContext } from '../context/layoutContext';
import { IconGroupBody } from '../styles/layOutStyles';
import { getStorageInfoData } from '../constants/index';

import Flicking from '@egjs/react-flicking';
import '@egjs/react-flicking/dist/flicking.css';
import '@egjs/react-flicking/dist/flicking-inline.css';
import '@egjs/flicking-plugins/dist/arrow.css';

const ICONLIST = [
  { id: 'youtube', title: 'FTV \n 유튜브', img: '/assets/Ftv/Icon/ic_youtube.png' },
  { id: 'facebook', title: 'FTV \n 페이스북', img: '/assets/Ftv/Icon/ic_facebook.png' },
  { id: 'instagram', title: 'FTV \n 인스타그램', img: '/assets/Ftv/Icon/ic_instargram.png' },
  { id: 'naverTV', title: 'FTV \n 네이버 티비', img: '/assets/Ftv/Icon/ic_navertv.png' },
  { id: 'blog', title: 'FTV \n 네이버 블로그', img: '/assets/Ftv/Icon/ic_naverblog.png' },
  { id: 'kakaoTV', title: 'FTV \n 카카오 티비', img: '/assets/Ftv/Icon/ic_kakaotv.png' },
];

const IconGroup = () => {
  const { matchese } = useContext(LayoutContext);
  const [info, setInfo] = useState('');

  useEffect(() => {
    setInfo(getStorageInfoData('company'));
  }, []);

  const goSite = url => {
    if (!url) return;

    window.open(url, '_blank');
  };

  const iconWebRender = () => {
    return ICONLIST.map((sns, idx) => {
      return <SnsIcon key={`snsicon_${idx}`} onClick={() => goSite(info[sns?.id])} title={sns.title} img={sns.img} matchese={matchese} />;
    });
  };

  const iconMobileRender = () => {
    return (
      <>
        <Flicking align='prev' circular='true'>
          {ICONLIST.map((sns, idx) => {
            return (
              <div className='flicking-panel' key={`snsIcon_${idx}`} style={{ width: `${100 / 3}%` }}>
                <SnsIcon key={`snsicon_${idx}`} onClick={() => goSite(info[sns?.id])} title={sns.title} img={sns.img} matchese={matchese} />
              </div>
            );
          })}
        </Flicking>
      </>
    );
  };

  return (
    <>
      <IconGroupBody>{matchese ? iconMobileRender() : iconWebRender()}</IconGroupBody>
    </>
  );
};

export default IconGroup;
